import React, { PropsWithChildren } from "react";
import styles from "./InputLabel.module.css";
const sizeStyles = {
  small: styles.InputLabel__Small,
  medium: styles.InputLabel__Medium,
  large: styles.InputLabel__Large,
};
export const InputLabel: React.FC<
  PropsWithChildren<{
    number?: number;
    for?: string;
    size?: "small" | "medium" | "large";
  }>
> = ({ children, for: htmlFor, number, size = "medium" }) => {
  return (
    <label
      className={styles.InputLabel + " " + sizeStyles[size]}
      htmlFor={htmlFor}
    >
      {number && <span className={styles.InputLabel__Circle}>{number}</span>}
      {children}
    </label>
  );
};
